import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IffhsService } from 'src/app/data-services/iffhs.service';
import { AuthenticationService } from 'src/app/data-services/authentication.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-club-photos',
  templateUrl: './club-photos.component.html',
  styleUrls: ['./club-photos.component.css']
})
export class ClubPhotosComponent implements OnInit {
  id: number;
  countryData: any = {};
  clubData: any = {};
  currentUser: any;
  searchText: any;
  status: boolean;
  photos = [];
  videos = [];
  selectFriend: any = {};
  isLoaderVisible = false;
  selectedPhoto: any = {};
  constructor(
    private route: ActivatedRoute,
    private iffhsService: IffhsService,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    this.route.queryParams.subscribe(params => this.id = params.id);
    this.getClubProfile();
    this.getPhotos();
  }
  getClubProfile() {
    this.isLoaderVisible = true;
    const data = {
      clubId: this.id,
    };
    this.iffhsService.getClubProfile(data).subscribe((res: any) => {
      this.clubData = res.club;
      this.countryData = res.country;
      this.isLoaderVisible = false;
    });
  }
  getPhotos() {
    this.isLoaderVisible = true;
    const data = {
      clubId: this.id,
    };
    this.iffhsService.getMedia(data).subscribe((res: any) => {
      this.photos = res.photos;
      this.videos = res.videos;
      this.isLoaderVisible = false;

    });
  }
  openModal(modal: any, photo: any) {
    this.selectedPhoto = photo;
    modal.show();
  }
  closeModal(modal: any) {
    modal.hide();
  }
}
